import React from 'react';
/**
 * Category description block for Wacoku Products.
 *
 * Wrapped in `.category-description` / `wf-category-description` so
 * WebsiteForge can dynamically populate this region at import time.
 */
export function Description() {
  return <div className="category-description wf-category-description mb-12 max-w-4xl" data-id="element-970">
      <div className="prose prose-gray text-gray-700 text-base sm:text-lg leading-relaxed" data-id="element-971">
        WT-approved Wacoku protective equipment, competition uniforms, and
        training accessories. Lightweight, durable, and trusted by athletes from
        beginner to elite levels.
      </div>
    </div>;
}